import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicReviewsFormGroup, CAROUSEL_DEFAULT_TITLE, LIST_DEFAULT_TITLE } from '../../model';
import { DynamicReviewsExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import {
  LAYOUT_OPTIONS,
  RATING_BADGE_TYPE_OPTIONS,
  CAROUSEL_NAVIGATION_OPTIONS,
  STAR_POSITION_OPTIONS,
  BORDER_OPTIONS,
  BORDER_WIDTH_OPTIONS,
  CORNER_RADIUS_OPTIONS,
  PADDING_OPTIONS,
  BACKGROUND_COLOR_OPTIONS,
  DYNAMIC_FIELDS_MENTION_CONFIG,
} from './dynamic-reviews-form-appearance.config';

@Component({
  selector: 'dynamic-reviews-form-appearance',
  templateUrl: './dynamic-reviews-form-appearance.component.html',
  styleUrls: ['./dynamic-reviews-form-appearance.component.scss'],
  standalone: false,
})
export class DynamicReviewsFormAppearanceComponent {
  @Input() formGroup: FormGroup<DynamicReviewsFormGroup>;

  LayoutStyle = DynamicReviewsExtension.LayoutStyle;
  RatingBadgeType = DynamicReviewsExtension.RatingBadgeType;
  CarouselNavigationStyle = DynamicReviewsExtension.CarouselNavigationStyle;
  StarPosition = DynamicReviewsExtension.StarPosition;
  carouselDefaultTitle = CAROUSEL_DEFAULT_TITLE;
  listDefaultTitle = LIST_DEFAULT_TITLE;

  layoutOptions = LAYOUT_OPTIONS;
  ratingBadgeTypeOptions = RATING_BADGE_TYPE_OPTIONS;
  carouselNavigationOptions = CAROUSEL_NAVIGATION_OPTIONS;
  starPositionOptions = STAR_POSITION_OPTIONS;
  borderOptions = BORDER_OPTIONS;
  borderWidthOptions = BORDER_WIDTH_OPTIONS;
  cornerRadiusOptions = CORNER_RADIUS_OPTIONS;
  paddingOptions = PADDING_OPTIONS;
  backgroundColorOptions = BACKGROUND_COLOR_OPTIONS;
  dynamicFieldsMentionConfig = DYNAMIC_FIELDS_MENTION_CONFIG;

  get currentLayoutStyle(): DynamicReviewsExtension.LayoutStyle {
    return this.formGroup.controls.layoutStyle.value;
  }

  get isRatingBadge(): boolean {
    return this.currentLayoutStyle === DynamicReviewsExtension.LayoutStyle.RATING_BADGE;
  }

  get isCarousel(): boolean {
    return this.currentLayoutStyle === DynamicReviewsExtension.LayoutStyle.REVIEW_CAROUSEL;
  }

  get isList(): boolean {
    return this.currentLayoutStyle === DynamicReviewsExtension.LayoutStyle.REVIEW_LIST;
  }

  get isStarHidden(): boolean {
    return this.formGroup.get('carouselConfig.starPosition')?.value === DynamicReviewsExtension.StarPosition.NONE;
  }

  get carouselContentControl() {
    return this.formGroup?.controls?.carouselConfig?.controls?.description;
  }

  get listDescriptionControl() {
    return this.formGroup?.controls?.listConfig?.controls?.description;
  }

  get carouselContentError(): string | null {
    return this.formGroup.hasError('missingCarouselReviewText') && this.formGroup.touched
      ? 'Dynamic field {review_text} is mandatory'
      : null;
  }

  get listDescriptionError(): string | null {
    return this.formGroup.hasError('missingListReviewText') && this.formGroup.touched
      ? 'Dynamic field {review_text} is mandatory'
      : null;
  }

  selectLayout(layout: DynamicReviewsExtension.LayoutStyle) {
    this.formGroup.controls.layoutStyle.setValue(layout);

    if (
      layout === DynamicReviewsExtension.LayoutStyle.REVIEW_CAROUSEL ||
      layout === DynamicReviewsExtension.LayoutStyle.REVIEW_LIST
    ) {
      this.formGroup.markAsTouched();
    }
  }
}
